import { Builder } from '@builder.io/react';

import CTASimpleCentered from './index';

Builder.registerComponent(CTASimpleCentered, {
  name: 'CTASimpleCentered',
  inputs: [
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'border',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'theme',
      type: 'string',
      enum: ['dark', 'light', 'blacknwhite']
    },
    {
      name: 'useHubSpotCTA',
      type: 'boolean',
      defaultValue: 'true'
    },
    {
      showIf: `options.get('useHubSpotCTA') === false`,
      name: 'formId',
      type: 'string'
    },
    {
      showIf: `options.get('useHubSpotCTA') === true`,
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              type: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          showIf: `options.get('hubspotModal')`,
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        }
      ]
    }
  ]
});
